import React, { Component } from 'react';

import { connect } from 'react-redux';

import { Elements } from 'react-stripe-elements';

import { withRouter } from 'react-router-dom';

import { success } from 'redux/ducks/Flash';
import {
  reset,
  retrieveSource,
  submit,
  updateField,
} from 'redux/ducks/Payment';

import CreditCard from './CreditCard';
import Checking from './Checking';

export class EditPaymentScene extends Component {
  state = {
    loadedSource: false,
  };

  componentWillMount() {
    if (this.props.user &&
      !this.props.payment.source.id &&
      !this.state.loadedSource) {
      this.setState({ loadedSource: true });
      this.props.retrieveSource(this.props.user.id);
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.payment.success) {
      this.props.success('Your Payment Information Was Successfully Updated');
      this.props.history.push('/dashboard');
    }

    if (newProps.user &&
      !this.props.payment.source.id &&
      !this.state.loadedSource) {
      this.setState({ loadedSource: true });
      this.props.retrieveSource(this.props.user.id);
    }
  }

  componentWillUnmount() {
    this.props.reset();
  }

  enableSubmit = () => {
    return (
      (this.props.payment.stripeTerms || this.props.payment.source.id) &&
      (
        (
          this.props.payment.object === 'card' &&
          this.props.payment.token &&
          this.props.validation.card.valid
        ) || (
          this.props.payment.object === 'bank_account' &&
          this.props.validation.check.valid
        )
      )
    );
  };

  hasSource = () => {
    return this.props.payment.source.id ? true : false;
  };

  onCancel = () => {
    this.props.history.push('/dashboard');
  };

  onFieldChange = (field, event) => {
    this.props.updateField(field, event.currentTarget.value);
  };

  onSubmit = () => {
    this.props.submit(this.props.user.id, this.props.payment.token, this.props.payment.check.plaid);
  };

  onTermsChanged = (event) => {
    this.props.updateField('stripeTerms', event.target.checked);
  };

  submitText = () => {
    return this.hasSource() ? 'update payment' : 'finish';
  };

  render() {
    return (
      <div className="editPaymentScene">
        {this.hasSource() ?
          <h2>edit Payment</h2> :
          <h2>add Payment</h2>
        }
        {!this.hasSource() &&
          <p>Almost there! To complete your account, please add your payment information. This will be used to pay the Staff that work your events.</p>
        }

        <form>
          <h3>select a payment type</h3>
          <div className="form-group row payment-types">
            <div className="col-lg-6">
              <label className="radio">
                <div>
                  Credit Card
                </div>
                <div className="credit-cards">
                  <img src={require('./visa.svg')} alt="Visa" />
                  <img src={require('./mastercard.svg')} alt="MasterCard" />
                  <img src={require('./amex.svg')} alt="American Express" />
                  <img src={require('./discover.svg')} alt="Discover" />
                </div>
                <input type="radio"
                  name="object"
                  value="card"
                  checked={this.props.payment.object === 'card'}
                  onChange={this.onFieldChange.bind(null, 'object')} />
                <span></span>
              </label>
            </div>
            <div className="col-lg-6">
              <label className="radio">
                ACH (checking)
                <input type="radio"
                  name="object"
                  value="bank_account"
                  checked={this.props.payment.object === 'bank_account'}
                  onChange={this.onFieldChange.bind(null, 'object')} />
                <span></span>
              </label>
            </div>
          </div>
          {this.props.payment.object === 'card' ?
            <Elements><CreditCard user={this.props.user} /></Elements> :
            <Elements><Checking user={this.props.user} /></Elements>
          }
          {(this.props.payment.loadedSource && !this.props.payment.source.id) &&
            <label className="checkbox stripe-terms">
              I have read and agree to comply with the <a href="https://stripe.com/us/connect-account/legal" target="_blank" rel="noopener noreferrer">Stripe Connected Account Agreement</a>
              <input type="checkbox" name="stripeTerms" onChange={this.onTermsChanged} />
              <span></span>
            </label>
          }
          <div className="controls row">
            <div className="cancel-container col-sm-3">
              <a className="btn" onClick={this.onCancel}>Cancel</a>
            </div>
            <div className="update-payment-button col-sm-6 col-lg-6">
              <button type="button" className="btn btn-danger bold-button float-right" onClick={this.onSubmit} disabled={!this.enableSubmit()}>{this.submitText()}</button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    payment: state.payment,
    user: state.session.currentUser,
    validation: state.payment.validation,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    reset: () => dispatch(reset()),
    retrieveSource: (userId) => dispatch(retrieveSource(userId)),
    submit: (userId, token, plaid) => dispatch(submit(userId, token, plaid)),
    success: (message) => dispatch(success(message)),
    updateField: (field, value) => dispatch(updateField(field, value)),
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(EditPaymentScene)
);